import { AllOperationIds, OpalApiRequestParams } from '../schema'

export type OperationQueryParams<TOperationId extends AllOperationIds> =
  'query' extends keyof OpalApiRequestParams<TOperationId>
    ? OpalApiRequestParams<TOperationId>['query']
    : never

export type Resources =
  | 'board'
  | 'board_object'
  | 'block'
  | 'calendar'
  | 'plan'
  | 'view'
  | 'workflow'

export type AllQueriesForResource = {
  workspaceUuid: string
}

export type CollectionQueryKey<TOperationId extends AllOperationIds> =
  AllQueriesForResource & {
    queryParams: OperationQueryParams<TOperationId> | null
  }

export type SingleResourceQueryKey<TOperationId extends AllOperationIds> =
  CollectionQueryKey<TOperationId> & {
    resourceId: string
  }

export type QueryKeyIdentifiers<TOperationId extends AllOperationIds> =
  | AllQueriesForResource
  | CollectionQueryKey<TOperationId>
  | SingleResourceQueryKey<TOperationId>

export const isIdentifierForSingleResource = <
  TOperationId extends AllOperationIds,
>(
  record: Record<string, unknown>
): record is SingleResourceQueryKey<TOperationId> => 'resourceId' in record

export const isIdentifierForCollection = <TOperationId extends AllOperationIds>(
  record: Record<string, unknown>
): record is CollectionQueryKey<TOperationId> => 'queryParams' in record
